import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr1010',
    ecrans: ['00-2'],
    params: ['id', '?demcleint', 'stamnetabref', 'avicleintref', '?stamnetabori', '?avicleintori']
});
